import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import './CheckBoxInputStyles.scss';
import { useIntl } from 'react-intl';
import { Icons } from '../../base/BootstrapComponents';
import { optionClassFormatter } from '../../../utils/formatters';

export default function RadioList(props) {
  const {
    children = null,
    className = '',
    label = '',
    clearFilter = () => {},
    setFilterValue = () => {},
    filter = {},
    keys = [],
    selectedValue = '',
  } = props;
  const [isOpen, setOpen] = useState(false);
  const blockRef = useRef(null);
  const blockArrow = useRef(null);
  const id = `check-box-accordion-${Math.random() * 10000}`;
  const handleClickOutside = event => {
    // if ((blockRef && (blockRef.current && blockRef.current.contains(event.target))) && !blockArrow.current.contains(event.target)) {
    //   debugger;
    //   setOpen(!isOpen);
    // }
  };
  const intl = useIntl();
  const { formatMessage } = intl;
  const value = selectedValue ? <div className={optionClassFormatter(selectedValue)}>{formatMessage({ id: selectedValue.nameId, defaultMessage: ' ' })}</div> : null;
  const keyDown = event => {
    if (event.keyCode === 27 && isOpen) {
      setOpen(false);
      event.preventDefault();
      event.stopPropagation();
    }
  };

  useEffect(
    () => {
      if (selectedValue) {
        setOpen(false);
      }
    },
    [selectedValue],
  );

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener('keydown', keyDown);
    // window.customEventListener.addEventListener('scroll', handleScroll, id);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside.bind(this));
      window.removeEventListener('keydown', keyDown.bind(this));
      // window.customEventListener.removeEventListener('scroll', id);
    };
  }, []);

  return (
    <div className={classNames('check-box-accordion radio-list', { open: isOpen, selected: isOpen || value }, className)}>
      <div className="cbl-accordion-label" ref={blockRef} onClick={() => { setOpen(!isOpen); }}>
        <div className="accordion-label-text">{label}</div>
        {value }
        <div className="accordion-icons accordion-icons-arrow" ref={blockArrow}>
          { isOpen && value ? <div style={{ width: 20, height: 20 }} onClick={() => clearFilter()}><Icons icon="close" customIcon className="close" /></div> : null}
          <Icons customIcon className="check-box-accordion-icon" width={12} height={8} icon="expand-more" onClick={() => { setOpen(!isOpen); }} />
        </div>
      </div>
      <div className="check-box-accordion-content">
        {children}
      </div>
    </div>
  );
}
